var _rect, _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgProducts = function SvgProducts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 110 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 80,
    rx: 8,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 23.775a7 7 0 0 1 7-7h39a7 7 0 0 1 7 7v37a7 7 0 0 1-7 7H35a7 7 0 0 1-7-7v-37Z",
    fill: "url(#products_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.507 15.202a5.094 5.094 0 0 1 0 7.204l-2.574 2.574-8.914-8.914 2.574-2.574a5.096 5.096 0 0 1 7.206 0l1.708 1.71Z",
    fill: "#384952"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.934 24.98 56.619 48.295h-.001l-8.914-8.913L71.02 16.066l8.914 8.914Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m47.705 39.382 8.913 8.914-.083.083-12.329 3.415 3.415-12.33.084-.082Z",
    fill: "#5298F4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "products_svg__a",
    x1: 103.225,
    y1: 92.5,
    x2: 10.5,
    y2: -0.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};

export default SvgProducts;